<template>
  <section class="states">
    <div class="card-actions card">
      <div class="card-content">
        <div class="content flex md:flex-row flex-col space-y-4 md:space-y-0">
          <h1 class="title">
            State Laws Configuration
          </h1>
          <button
            class="button primary"
            @click="creatingDialog = true"
          >
            Add a state
          </button>
        </div>
      </div>
    </div>

    <DialogStates
      v-model="creatingDialog"
      :item="selectedItem"
      :organization-uuid="selectedOrganizationUuid"
      :created-states="states"
      @recorded="handleEditCreationDialog"
      @edit-template="handleEditTemplateClick"
      @close="selectedItem = null"
    />

    <br>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <br>
        <div class="state_block">
          <div class="grid_states">
            <div
              v-for="(state, idx_state) in states"
              :key="'state_' + idx_state"
              class="row"
            >
              <div class="card">
                <header class="card-header">
                  <div class="card-header-title is-primary-border">
                    <span class="state-name">
                      {{ getStateName(state) }}
                    </span>
                  </div>
                  <div class="card-header-icon">
                    <div
                      class="dropdown"
                      :class="{'is-active': state.show_menu}"
                    >
                      <div class="dropdown-trigger">
                        <button
                          class="button is-white"
                          aria-haspopup="true"
                          aria-controls="dropdown-menu"
                          @click="state.show_menu = !state.show_menu"
                        >
                          <span class="icon is-small">
                            <i
                              class="fas fa-ellipsis-v"
                              aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        id="dropdown-menu-state"
                        class="dropdown-menu"
                        role="menu"
                      >
                        <div class="dropdown-content">
                          <button
                            class="dropdown-item"
                            @click="showEditStateModal(state)"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
            <div
              v-if="!states.length"
              class="card card-header-title"
            >
              No Data Available
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal edit-template-modal"
      :class="{'is-active' : show_edit_template_modal}"
    >
      <div
        class="modal-background"
        @click="hideEditTemplateModal()"
      />
      <div class="modal-content">
        <div class="box">
          <p class="title">
            Edit template
          </p>
          <div class="modal-body">
            <div v-if="!showTemplates">
              <div class="card card-header-title">
                No Data Available
              </div>
            </div>
            <div v-else>
              <div>
                <p
                  v-if="templateInfo.stateName"
                  class="template-info"
                >
                  <span class="info">State name:</span>
                  <span>{{ templateInfo.stateName }}</span>
                </p>
              </div>
              <div class="columns template-switcher">
                <div class="column is-12 is-paddingless has-text-centered templates">
                  <div class="field has-addons has-addons-centered flex_wrap_fields">
                    <div
                      v-for="item in template"
                      :key="item.uuid"
                      class="control"
                    >
                      <button
                        class="button primary"
                        :class="[show[item.uuid] ? '' : 'is-outlined']"
                        @click="showDocument([item.uuid])"
                      >
                        {{ item.template_name }}
                      </button>
                    </div>
                    <div
                      class="control"
                      style="margin-left: 5px"
                    >
                      <button
                        class="button primary"
                        :class="['is-outlined']"
                        @click="showAddTemplateModal()"
                      >
                        Add New Template
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="edit-template-content">
                <div>
                  <div
                    v-for="item in template"
                    v-show="show[item.uuid]"
                    :key="item.uuid"
                    class="columns template_display"
                  >
                    <div class="column is-12 is-paddingless">
                      {{ item.template_name }}
                      <editable-area
                        v-if="role === roles.SUPER_ADMIN"
                        :handle-save="(content, file) => handleTemplateSave(content, file, item.uuid)"
                        :class-name="'template-page'"
                        :pdf-file="item.pdf"
                        :content="item.template"
                      />
                      <div
                        v-else
                        class="template-page"
                        v-html="item.template"
                      />
                      <div class="modal-actions control">
                        <button
                          type="button"
                          class="button is-outlined close_modal"
                          @click="hideEditTemplateModal()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="templateVariables"
                  class="template-variables"
                >
                  <template v-for="(templateVariable, index) in templateVariables">
                    <div
                      :key="`templateVariable-${index}`"
                      class="template-variable"
                    >
                      <p>{{ templateVariable.name }}</p>
                      <p>{{ templateVariable.description }}</p>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideEditTemplateModal()"
      />
    </div>
    <div
      class="modal add-template-modal"
      :class="{'is-active' : show_add_template_modal}"
    >
      <div
        class="modal-background"
        @click="hideAddTemplateModal()"
      />
      <div class="modal-content">
        <div class="box">
          <p class="title">
            Add new template
          </p>
          <div class="modal-body">
            <label class="minimum-number-label">Template name</label>
            <div class="field">
              <div class="control">
                <input
                  v-model="templateName"
                  class="input is-mandatory"
                  :class="errors.templateName.visible ? 'has-error' : ''"
                  placeholder="Template name"
                  type="text"
                >
                <span v-if="errors.templateName.visible">{{ errors.templateName.message }}</span>
              </div>
            </div>
          </div>
          <div class="modal-actions control">
            <button
              type="button"
              class="button is-outlined"
              @click="hideAddTemplateModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="button primary"
              @click="createTemplate()"
            >
              Create
            </button>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideAddTemplateModal()"
      />
    </div>
  </section>
</template>
<script>
// @todo remove this
/* eslint-disable camelcase */

import UserService from '../../services/user.service';
import TemplateService from '../../services/template.service';
import EditableArea from '../core/EditableArea';
import { Roles } from '@/constants';

const userService = new UserService();
const templateService = new TemplateService();

const TEMPLATES = {
  CONTENT_NOTICE: 'content_notice',
  CONTENT_SALE: 'content_sale'
};

const defaultErrors = {
  templateName: {
    visible: false,
    message: ''
  }
};

const emptyTemplate = [{
  name: '',
  uuid: null,
  email_subject: '',
  content_notice: '',
  content_sale: '',
  content_sms: '',
  content_ad: '',
  content_opposition_form: '',
  is_legal_state_template: false,
  is_company_template: false,
  pdf: '',
  pdf2: '',
  images_pdfs: ''
}];

export default {
  name: 'StatesComponent',
  components: {
    EditableArea,
    DialogStates: () => import('./dialogs/DialogState.vue')
  },
  data() {
    return {
      creatingDialog: false,
      stateUuid: null,
      selectedOrganizationUuid: null,
      states: [],
      templateName: '',
      availableStates: [],
      role: this.$store.state.user.role,
      roles: Roles,
      stateEditMode: false,
      stateToEdit: null,
      errors: { ...defaultErrors },
      restrictValue: '[0-9]',
      show_edit_template_modal: false,
      show_add_template_modal: false,
      editableTemplates: {
        ...TEMPLATES
      },
      template: {
        ...emptyTemplate
      },
      show: {
        notice: true,
        sale: false
      },
      showTemplates: false,
      templateVariables: null,
      templateInfo: {
        stateName: ''
      },
      selectedItem: null
    };
  },
  mounted() {
    const { state } = this.$store;
    const selectedOrganization = { ...state.selectedOrganization };
    const organization = { ...state.organization };
    // eslint-disable-next-line no-nested-ternary
    const currentOrganization = !this.activateMode && selectedOrganization && Object.keys(selectedOrganization).length ? selectedOrganization : organization && Object.keys(organization).length ? organization : {};
    this.selectedOrganizationUuid = currentOrganization && Object.keys(currentOrganization).length ? currentOrganization.uuid : '';
    this.getStates();
  },
  methods: {
    handleEditCreationDialog() {
      this.selectedItem = null;
      this.creatingDialog = false;
      this.getStates();
    },
    createTemplate() {
      const self = this;
      if (!this.templateName) {
        this.errors.templateName.visible = true;
        this.errors.templateName.message = 'Field is mandatory';
        return;
      }
      const data = new FormData();
      data.append('name', this.templateName);

      userService.createTemplate(data).then((response) => {
        const { status, message } = response.data;
        if (status === 'success') {
          self.$root.$emit('showToast', {
            message: message || 'Template successfully created\'}',
            options: { cssClass: 'is-success', duration: 5000 }
          });
          self.hideAddTemplateModal();
          self.getTemplates(self.stateUuid);
        } else {
          self.$root.$emit('showToast', {
            message: message || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        }
      });
    },
    getStateName(state = {}) {
      return [state.name, state.abbreviation].filter((it) => it).join(', ');
    },
    getStates() {
      const self = this;
      userService.getStates(this.selectedOrganizationUuid)
        .then((response) => {
          const { status, result } = response.data;

          if (status === 'success') {
            self.states = result.map((it) => ({ ...it, show_menu: false }));
            if (self.$root.showStateAdd) {
              this.creatingDialog = true;
              self.$root.showStateAdd = false;
            }
          } else {
            self.$root.$emit('showToast', {
              message: 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message: 'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    showEditStateModal(state) {
      this.selectedItem = { ...state };
      this.creatingDialog = true;
    },
    handleEditTemplateClick(uuidState) {
      this.creatingDialog = false;
      this.stateUuid = uuidState;
      this.getTemplateVariables();
      this.getTemplates(uuidState);
      this.showEditTemplateModal();
    },
    showEditTemplateModal() {
      this.show_edit_template_modal = true;
    },
    hideEditTemplateModal() {
      this.show_edit_template_modal = false;
      this.template = {
        ...emptyTemplate
      };
      this.errors = { ...defaultErrors };
      this.templateVariables = null;
    },
    hideAddTemplateModal() {
      this.show_add_template_modal = false;
    },
    showAddTemplateModal() {
      this.show_add_template_modal = true;
    },
    handleTemplateSave(content, file, uuid) {
      const self = this;
      const data = new FormData();
      data.append('template', content);
      if (file) {
        data.append('file', file);
      }
      templateService.updateTemplate(uuid, data)
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', { message: message || 'Template successfully updates', options: { cssClass: 'is-success', duration: 5000 } });
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    getTemplates(companyUuid) {
      const self = this;
      templateService.getTemplateById(companyUuid)
        .then((response) => {
          const { status, result } = response.data;
          if (status === 'success') {
            self.showTemplates = true;
            self.templateInfo = {
              stateName: result.state_name
            };
            self.template = result.state_template;
            let count = 0;
            // eslint-disable-next-line guard-for-in, no-restricted-syntax
            for (const i in self.template) {
              self.show[self.template[i].uuid] = count === 0;
              // eslint-disable-next-line no-plusplus
              count++;
            }
            self.$forceUpdate();
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
            self.showTemplates = false;
          }
        })
        .catch(() => {
          self.showTemplates = false;
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    getTemplateVariables() {
      const self = this;
      templateService.getTemplateVariables()
        .then((response) => {
          const { status, result, message } = response.data;
          if (status === 'success') {
            self.templateVariables = result;
          } else {
            self.$root.$emit('showToast', { message: message || 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to perform this action. Be sure to be connected and to have access to this action', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    showDocument(index) {
      const self = this;
      Object.keys(self.show).forEach((item) => {
        self.show[item] = false;
      });
      self.show[index] = true;
      this.$forceUpdate();
    }
  }
};
</script>
<style scoped src='../../../public/assets/css/bulma-extension/bulma-tooltip.min.css'></style>
<style scoped lang="scss">
.states {
  .is-borderless {
    border: 0;
  }

  .grid_states {
    .row {
      margin-top: 10px;

      .card {
        height: 100%;
        display: flex;
        flex-direction: column;

        .card-header {
          margin: 0;

          .card-header-title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            border-left-width: 4px;
            border-left-style: solid;
            padding: 0 1rem;
            font-weight: 400;

            .location-name {
              font-size: 18px;
              font-weight: bold;
            }

            .location-address {
              font-size: 14px;
              color: #81868D;
            }
          }

          .card-header-icon {
            max-width: 72px;
          }
        }

        .card-content {
          border-top: 1px solid #ededed;
        }
      }
    }
  }

  .card-actions {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 2;

    .content {
      display: flex;
      justify-content: space-between;

      .title {
        margin: 0;
      }
    }
  }

  .add-state {
    .modal-content {
      max-width: 700px;

      .box {

        .title {
          font-size: 24px;
          font-weight: bold;
          margin: 0;
        }

        .sub-title {
          font-size: 16px;
          margin: 5px 0 10px;
        }

        .minimum-number-label {
          margin-bottom: 0.75rem;
          display: block;
        }

        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 25px;

          .button {
            width: 120px;
          }
        }

        .checkbox {
          display: flex;
          align-items: center;

          label {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .add-state {
    .modal-body {
      .select {
        margin-top: 25px;
      }

      .input {
        margin-top: 25px;
        resize: none;
      }
    }
  }

  .edit-template-modal {
    width: 100%;
    height: 100%;

    .modal-content {
      width: inherit;
      height: inherit;
      max-height: unset;

      .box {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .modal-body {
          .template-info {
            display: flex;

            .info {
              width: 135px;
            }
          }

          .template-switcher {
            margin-top: 20px;
          }
        }
      }

      .templates {
        margin-bottom: 5px;
      }

      .edit-template-content {
        display: flex;
        justify-content: space-between;

        .template_display {
          margin: 0;
        }

        .template-variables {
          margin-top: 65px;
          margin-right: 15px;

          .template-variable {
            display: flex;
            justify-content: space-between;

            p {
              margin-top: 10px;
              width: 50%;

              +p {
                margin-left: 15px;
                text-align: left;
              }
            }
          }
        }
      }
    }
    .close_modal {
      top:-53px
    }
    .modal-close {
      background-color: rgba(10, 10, 10, 0.3);
    }
  }
  .flex_wrap_fields {
    flex-wrap: wrap;
      .control {
        margin-bottom: 5px;
      }
  }
  .add-template-modal {
    .modal-content {
      width: 700px;

      .box {

        .title {
          font-size: 24px;
          font-weight: bold;
          margin: 0;
        }

        .sub-title {
          font-size: 16px;
          margin: 5px 0 10px;
        }

        .minimum-number-label {
          margin-bottom: 0.75rem;
          display: block;
        }

        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 25px;

          .button {
            width: 120px;
          }
        }

        .checkbox {
          display: flex;
          align-items: center;

          label {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>
